import React from 'react';
import NotificationBell from '../notifications/NotificationBell';

/** Header notification entry: bell + badge + dropdown (wrap app with NotificationProvider). */
const HeaderNotificationBell = () => <NotificationBell />;

export default HeaderNotificationBell;
